import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { cartIdStore } from 'src/api/orderIdStore';
import { ConnectConfirmationPage } from 'src/apps/checkout/app/pages/Connect.Confirmation';

const searchSchema = z.object({
  payment_intent_client_secret: z.string(),
  payment_intent: z.string(),
  redirect_status: z.string(),
});

export const Route = createFileRoute(
  '/_auth/_only-header/store/connect/confirmation'
)({
  validateSearch: zodValidator(searchSchema),
  beforeLoad({ search }) {
    if (!cartIdStore.get()) {
      throw redirect({ to: '/subscriptions' });
    }
    if (search.redirect_status === 'failed') {
      throw redirect({
        to: '/store/connect/checkout',
        search: { redirect_status: 'failed' },
      });
    }
  },
  component: () => <ConnectConfirmationPage />,
});
